/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:aa8179b0-619b-40d3-b29e-a4d20be65b9a",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_KxTtYsLeu",
    "aws_user_pools_web_client_id": "4cm2sdl7t02265ko2fqa5id68c",
    "oauth": {},
    "federationTarget": "COGNITO_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://v6uz4sqnkjaznhjzexxn3e2thu.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "stripeAPI",
            "endpoint": "https://5y6fd4b4m4.execute-api.us-east-2.amazonaws.com/froshprod",
            "region": "us-east-2"
        }
    ],
    "aws_user_files_s3_bucket": "froshbitedevfroshprod-froshprod",
    "aws_user_files_s3_bucket_region": "us-east-2",
    "aws_content_delivery_bucket": "froshbite-dev-20200627143248-hostingbucket-froshprod",
    "aws_content_delivery_bucket_region": "us-east-2",
    "aws_content_delivery_url": "http://froshbite-dev-20200627143248-hostingbucket-froshprod.s3-website.us-east-2.amazonaws.com"
};


export default awsmobile;
